// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DialogService {
  confirm(message?: string): Observable<boolean> {
    const confirmation = window.confirm(message || 'Existen cambios sin guardar, ¿Está seguro de que quiere salir de esta página?.');
    return Observable.of(confirmation);
  };
}
